export default __webpack_public_path__ + "static/media/TrulyInbox_Logo.d8f0ea80.svg";